import addressFieldBuilder from './addressFieldBuilder'
import baseFieldBuilder, { BuiltFieldAttributes, FieldAttributesBuilder, FieldBuilderParams } from './baseFieldBuilder'
import cascadeDropDownBuilder from './cascadeDropDownBuilder'
import choicesBuilder from './choicesBuilder'
import dimensionsBuilder from './dimensionsBuilder'
import evaluationSettingBuilder from './evaluationSettingBuilder'
import examSettingBuilder from './examSettingBuilder'
import goodsItemsBuilder from './goodsItemsBuilder'
import likertChoiceStyleBuilder from './likertChoiceStyleBuilder'
import matrixScaleDimensionsBuilder from './matrixScaleDimensionsBuilder'
import ratingFieldBuilder from './ratingFieldBuilder'
import reservationItemsBuilder from './reservationItemsBuilder'
import statementsBuilder from './statementsBuilder'
import widgetMapBuilder from './widgetMapBuilder'

export const AI_SUPPORTED_FIELD_TYPES = [
  'NameField',
  'MobileField',
  'IdCardField',
  'EmailField',
  'AddressField',
  'RadioButton',
  'CheckBox',
  'DropDown',
  'TextField',
  'TextArea',
  'NumberField',
  'ESignatureField',
  'AttachmentField',
  'DateTimeField',
  'TimeField',
  'NpsField',
  'GeoField',
  'RatingField',
  'MatrixScaleField',
  'MatrixField',
  'LikertField',
  'GoodsField',
  'ReservationField',
  'SortField',
  'WidgetMap',
  'TableField',
  'CascadeDropDown',
  'LinkField',
  'SectionBreak',
]

const fieldBuildersMap: Partial<Record<string, FieldAttributesBuilder[]>> = {
  AddressField: [addressFieldBuilder],
  CascadeDropDown: [cascadeDropDownBuilder],
  CheckBox: [choicesBuilder, evaluationSettingBuilder, examSettingBuilder],
  DropDown: [choicesBuilder, evaluationSettingBuilder, examSettingBuilder],
  GoodsField: [goodsItemsBuilder],
  LikertField: [choicesBuilder, statementsBuilder, likertChoiceStyleBuilder],
  MatrixField: [statementsBuilder, dimensionsBuilder],
  MatrixScaleField: [statementsBuilder, matrixScaleDimensionsBuilder],
  NumberField: [examSettingBuilder],
  RadioButton: [choicesBuilder, evaluationSettingBuilder, examSettingBuilder],
  ReservationField: [reservationItemsBuilder],
  SortField: [choicesBuilder],
  TableField: [dimensionsBuilder],
  TextArea: [examSettingBuilder],
  TextField: [examSettingBuilder],
  WidgetMap: [widgetMapBuilder],
  RatingField: [ratingFieldBuilder],
}

export default function buildField(params: Pick<FieldBuilderParams, 'rawField' | 'scene'>): BuiltFieldAttributes {
  const { rawField, scene } = params

  const fieldBuilders = [baseFieldBuilder, ...(fieldBuildersMap[rawField.type] ?? [])]

  const attributes: BuiltFieldAttributes = {} as BuiltFieldAttributes
  for (const fieldBuilder of fieldBuilders) {
    const addedAttributes = fieldBuilder({ rawField, scene, attributes, buildField })
    if (addedAttributes) Object.assign(attributes, addedAttributes)
  }

  return attributes
}

export const CHOICES_FIELD_TYPES = [
  'RadioButton',
  'CheckBox',
  'DropDown',
  'LikertField',
  'SortField',
  'CascadeDropDown',
]
